import { BadgeCheck, MessageCircle, Shield, ArrowUpRight } from "lucide-react";

const WHATSAPP_NUMBER = "918055592955";
const WHATSAPP_TEXT = encodeURIComponent("Hi Yadav, I saw your trust strip on UID Infotech and would like to chat.");

/**
 * "Verified by Yadav" trust strip — places the founder's face and direct
 * WhatsApp line right under the hero to convert visitor trust into clicks.
 */
export default function FounderTrustStrip() {
  return (
    <section className="relative" data-testid="founder-trust-strip">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-2xl border border-cyan-400/25 bg-gradient-to-r from-[#0F172A] via-[#0A101D] to-[#0F172A] backdrop-blur-md">
          {/* Decorative cyan glow */}
          <div className="absolute -left-16 top-1/2 -translate-y-1/2 h-40 w-40 rounded-full bg-cyan-500/15 blur-3xl pointer-events-none" />
          <div className="absolute -right-12 -bottom-12 h-36 w-36 rounded-full bg-emerald-500/15 blur-3xl pointer-events-none" />

          <div className="relative flex flex-col sm:flex-row items-stretch sm:items-center gap-4 p-4 sm:p-5">
            {/* Avatar + Verified badge */}
            <div className="flex items-center gap-4 shrink-0">
              <div className="relative">
                <div
                  className="relative h-14 w-14 sm:h-16 sm:w-16 rounded-full overflow-hidden ring-2 ring-cyan-400/40 ring-offset-2 ring-offset-[#0A101D] shadow-[0_8px_24px_-8px_rgba(34,211,238,0.55)]"
                  data-testid="founder-avatar"
                >
                  <img
                    src="/yadav-bawane.webp"
                    alt="Yadav Bawane"
                    loading="lazy"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                {/* Verified tick */}
                <div className="absolute -bottom-1 -right-1 grid h-6 w-6 place-items-center rounded-full bg-cyan-400 ring-2 ring-[#0A101D]">
                  <BadgeCheck className="h-3.5 w-3.5 text-[#0A101D]" />
                </div>
              </div>

              {/* Mobile-only name (sits beside avatar) */}
              <div className="sm:hidden min-w-0">
                <div className="text-[10px] font-extrabold uppercase tracking-wider text-cyan-300 inline-flex items-center gap-1">
                  <Shield className="h-3 w-3" /> Verified Founder
                </div>
                <div className="text-sm font-bold text-white mt-0.5 truncate">Yadav Bawane</div>
                <div className="text-[11px] text-white/55 truncate">Founder, UID Infotech</div>
              </div>
            </div>

            {/* Desktop name block */}
            <div className="hidden sm:flex flex-col flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <span className="inline-flex items-center gap-1 rounded-full bg-cyan-500/15 border border-cyan-400/40 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-cyan-300">
                  <Shield className="h-3 w-3" /> Verified Founder
                </span>
              </div>
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="text-base sm:text-lg font-bold text-white">Yadav Bawane</span>
                <span className="text-white/30">·</span>
                <span className="text-sm text-white/70">Founder, UID Infotech</span>
                <span className="text-white/30 hidden md:inline">·</span>
                <span className="hidden md:inline-flex items-center gap-1.5 text-sm text-emerald-300 font-medium">
                  <span className="relative grid h-2 w-2 place-items-center">
                    <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60" />
                    <span className="relative h-1.5 w-1.5 rounded-full bg-emerald-400" />
                  </span>
                  Personally answers WhatsApp
                </span>
              </div>
              <div className="md:hidden mt-1 inline-flex items-center gap-1.5 text-xs text-emerald-300 font-medium">
                <span className="relative grid h-2 w-2 place-items-center">
                  <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60" />
                  <span className="relative h-1.5 w-1.5 rounded-full bg-emerald-400" />
                </span>
                Personally answers WhatsApp
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1FBA59] active:scale-[0.98] px-5 py-2.5 text-sm font-bold text-white shadow-[0_8px_24px_-8px_rgba(37,211,102,0.6)] transition-all shrink-0"
              data-testid="founder-whatsapp-cta"
            >
              <MessageCircle className="h-4 w-4" />
              <span>Message Yadav on WhatsApp</span>
              <ArrowUpRight className="h-3.5 w-3.5 opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
